/**
 * Parcels Details
 */

// React
import React, { useEffect } from 'react';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Store } from '../../../redux/reducers';
import { getDriverAction } from '../actions';

// Selector
import { createStructuredSelector } from 'reselect';
import {
  makeSelectDriver,
  makeSelectLoading,
  makeSelectError,
} from '../selectors';

//UI
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiAccountOutline,
  mdiFormatListCheckbox,
  mdiPhoneOutline,
  mdiMapMarkerOutline,
  mdiCarMultiple,
  mdiAccountKeyOutline,
  mdiCardAccountDetailsOutline,
  mdiCalendarToday,
  mdiBank,
  mdiClipboardTextMultipleOutline,
  mdiFormatColorFill,
  mdiOrderNumericAscending, mdiGasStationOutline, mdiCounter, mdiCurrencyUsd,
} from '@mdi/js';

// Helper
import {
  formaterPhoneNumber,
  translate,
} from '../../../utils/helpers';
import jMoment from 'moment-jalaali';

// Type
import { SelectorProps, Props } from './interfaces';
import { mdiPostOutline } from '@mdi/js/commonjs/mdi';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(0),
        },
      },
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    paper: {
      marginTop: '36px',
      marginBottom: '36px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
      '@media (max-width: 768px)': {
        padding: theme.spacing(0),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
      },
    },

    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    divider: {
      width: '98%',
      margin: '10px auto',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '10px',
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '28px',
    },
    contentlabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'justify',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
  })
);

export function Details(props: Props) {
  const classes = useStyles();

  useEffect(() => {
    const id = props.id;
    props?.getDriverWithIdActionDispatch(id);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={classes.root}>
      <Grid container spacing={5}>
        <Grid item xs={12} sm={4}>
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiAccountOutline}
                size={1}
                className={classes.icon}
              />
              {`نام راننده :  `}
            </span>

            <span>{props.driver.name}</span>
          </div>
        </Grid>

        <Grid item xs={12} sm={4}>
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiCalendarToday} size={1} className={classes.icon} />
              {`تاریخ تولد:  `}
            </span>

            <span>
              {props.driver.birthDate &&
                `${jMoment(props.driver.birthDate, 'YYYY/MM/DD')
                  .locale('fa')
                  .format('jYYYY/jMM/jDD')}`}
            </span>
          </div>
        </Grid>

        <Grid item xs={12} sm={4}>
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiCounter}
                size={1}
                className={classes.icon}
              />
              {`کد ملی :  `}
            </span>

            <span>{props.driver.nationalCode}</span>
          </div>
        </Grid>

        <Grid item xs={12} sm={4}>
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiAccountKeyOutline}
                size={1}
                className={classes.icon}
              />
              {`شناسه راننده:  `}
            </span>

            <span>{props.driver.id}</span>
          </div>
        </Grid>

        <Grid item xs={12} sm={4}>
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiPhoneOutline}
                style={{ transform: 'scale(-1, 1)' }}
                size={1}
                className={classes.icon}
              />
              {`شماره تماس راننده:  `}
            </span>
            <span>{formaterPhoneNumber(props.driver.phoneNumber)}</span>
          </div>
        </Grid>

        <Grid item xs={12} sm={4}>
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiCardAccountDetailsOutline}
                size={1}
                className={classes.icon}
              />
              {`نوع همکاری:  `}
            </span>

            <span>{translate(props.driver.employmentType)}</span>
          </div>
        </Grid>

        <Grid item xs={12} sm={4}>
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiCalendarToday} size={1} className={classes.icon} />
              {`تاریخ آغاز به کار:  `}
            </span>

            <span>
              {props.driver.employmentStartDate &&
                `${jMoment(props.driver.employmentStartDate, 'YYYY/MM/DD')
                  .locale('fa')
                  .format('jYYYY/jMM/jDD')}`}
            </span>
          </div>
        </Grid>

        <Grid item xs={12} sm={4}>
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiBank} size={1} className={classes.icon} />
              {`نام بانک:  `}
            </span>
            <span>{props.driver.bank}</span>
          </div>
        </Grid>

        <Grid item xs={12} sm={4}>
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiClipboardTextMultipleOutline}
                size={1}
                className={classes.icon}
              />
              {`شماره حساب:  `}
            </span>
            <span>
              <span>{props.driver.bankAccountNumber}</span>
            </span>
          </div>
        </Grid>

        <Grid item xs={12} sm={4}>
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiClipboardTextMultipleOutline}
                size={1}
                className={classes.icon}
              />
              {`شماره شبا:  `}
            </span>
            <span>
              <span>{props.driver.shabaNumber}</span>
            </span>
          </div>
        </Grid>

        <Grid item xs={12} sm={4}>
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiCarMultiple}
                style={{ transform: 'scale(-1, 1)' }}
                size={1}
                className={classes.icon}
              />
              {`نوع خودرو:  `}
            </span>
            <span>
              <span>{translate(props.driver.vehicleClass)}</span>
            </span>
          </div>
        </Grid>

        <Grid item xs={12} sm={4}>
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiFormatListCheckbox}
                size={1}
                style={{ transform: 'scale(-1, 1)' }}
                className={classes.icon}
              />
              {`مدل خودرو:  `}
            </span>

            <span>{props.driver.vehicleType}</span>
          </div>
        </Grid>

        <Grid item xs={12} sm={4}>
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiGasStationOutline}
                size={1}
                style={{ transform: 'scale(-1, 1)' }}
                className={classes.icon}
              />
              {`نوع سوخت:  `}
            </span>

            <span>{props.driver.fuel}</span>
          </div>
        </Grid>

        <Grid item xs={12} sm={4}>
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiCalendarToday} size={1} className={classes.icon} />
              {`سال ساخت:  `}
            </span>

            <span>
              {props.driver.productionYear}
            </span>
          </div>
        </Grid>

        <Grid item xs={12} sm={4}>
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiFormatColorFill}
                style={{ transform: 'scale(-1, 1)' }}
                size={1}
                className={classes.icon}
              />
              {`رنگ خودرو:  `}
            </span>
            <span>{props.driver?.color}</span>
          </div>
        </Grid>

        <Grid item xs={12} sm={4}>
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiOrderNumericAscending}
                size={1}
                className={classes.icon}
              />
              {`پلاک خودرو:  `}
            </span>
            <span>{props.driver?.plateNumber}</span>
          </div>
        </Grid>

        <Grid item xs={12} sm={4}>
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiPhoneOutline}
                style={{ transform: 'scale(-1, 1)' }}
                size={1}
                className={classes.icon}
              />
              {`شماره ثابت:  `}
            </span>
            <span>{props.driver?.homePhoneNumber}</span>
          </div>
        </Grid>

        <Grid item xs={12} sm={4}>
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiPostOutline}
                size={1}
                className={classes.icon}
              />
              {`نوع ضمانت نامه:  `}
            </span>
            <span>{props.driver?.warrantyType}</span>
          </div>
        </Grid>

        <Grid item xs={12} sm={4}>
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiCurrencyUsd}
                size={1}
                className={classes.icon}
              />
              {`مبلغ ضمانت نامه (تومان):  `}
            </span>
            <span>{props.driver?.warrantyAmount && new Intl.NumberFormat('fa-IR').format(props.driver?.warrantyAmount)}</span>
          </div>
        </Grid>

        <Grid item xs={12} sm={4}>
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiMapMarkerOutline}
                size={1}
                className={classes.icon}
              />
              {`آدرس:  `}
            </span>
            <span>{props.driver?.address}</span>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  driver: makeSelectDriver(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    getDriverWithIdActionDispatch: (id: number) =>
      dispatch(getDriverAction({ id })),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Details);
